<app-action-modal
  #actionModal
  [disabled]="submitted"
  [submitDisabled]="!canSubmit"
  [showHeader]="true"
  submitButtonClass="lty-btn-primary"
  size="md"
  headerIconState="primary"
  customModalClass="compose-modal"
  (submitted)="confirm()"
>
  <div class="d-flex justify-content-center align-items-center" headerIcon>
    <app-file-lines-icon width="20px" height="20px" color="var(--brand-700)" />
  </div>

  <ng-container mainTitle i18n>Ajouter un document</ng-container>

  <ng-container subtitle>
    <form class="lty-form compose-form mt-12" [formGroup]="form">
      <div class="form-group mb-16">
        <label for="cancellation-document-type" i18n
          >Type de document <span class="text-danger">*</span></label
        >
        <select
          class="form-control"
          id="cancellation-document-type"
          formControlName="type"
        >
          <option value="" disabled i18n>Choisissez un type</option>
          @for (type of types; track type) {
            <option [value]="type">
              {{ typeLabel(type) }}
            </option>
          }
        </select>
        @if (form.controls.type.touched && form.controls.type.invalid) {
          <div class="invalid" i18n>Veuillez choisir un type.</div>
        }
      </div>

      @if (isLetter) {
        <div class="form-group mb-16">
          <label for="cancellation-document-letter-date" i18n
            >Date de la lettre <span class="text-danger">*</span></label
          >
          <input
            class="form-control"
            type="date"
            id="cancellation-document-letter-date"
            formControlName="letterDate"
          />
          @if (
            form.controls.letterDate.touched && form.controls.letterDate.invalid
          ) {
            <div class="invalid" i18n>Veuillez indiquer la date.</div>
          }
        </div>
      }

      <div class="form-group mb-8">
        <label for="cancellation-document-file" i18n
          >Document <span class="text-danger">*</span></label
        >
        <app-file-input
          inputId="cancellation-document-file"
          accept="application/pdf"
          formControlName="file"
        />
        @if (form.controls.file.value && form.controls.file.errors?.['pdf']) {
          <div class="invalid" i18n>Seul un PDF peut être importé.</div>
        }
      </div>
    </form>
  </ng-container>

  <ng-container submitButtonLabel i18n>Ajouter</ng-container>
</app-action-modal>
